import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  type POPDFCustomFieldDisplay,
  type POPDFCustomFieldDisplayRow,
} from '@webapp/modules/purchasing/business-logic/use-cases/getPOPDFCustomFieldDisplay'
import { poPdfCustomFieldDisplayQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfCustomFieldDisplay'

type UseQueryPOPDFCustomFieldDisplayReturn = {
  poFields: POPDFCustomFieldDisplayRow[]
  orderItemFields: POPDFCustomFieldDisplayRow[]
  isLoading: boolean
  error: RepoError | null
}

export const useQueryPOPDFCustomFieldDisplay =
  (): UseQueryPOPDFCustomFieldDisplayReturn => {
    const { data, isLoading, error } = useQuery<
      POPDFCustomFieldDisplay,
      RepoError
    >(poPdfCustomFieldDisplayQueryConfig.display())

    return {
      poFields: data?.poFields ?? [],
      orderItemFields: data?.orderItemFields ?? [],
      isLoading,
      error: error ?? null,
    }
  }
